import { Button } from "@evertrue/et-components";
import PropTypes from "prop-types";
import EmailSignature from "./email-signature";

const EmailSignaturesLibrary = ({ selectedSignature, setSelectedSignature, signatures }) => {
  return (
    <div className="email-signature-library">
      <div className="email-signature-library--header">You can create up to 3 customized email signatures</div>
      <div className="email-signature-library--list">
        {signatures.map((signature, idx) => (
          <div key={signature.id}>
            <EmailSignature
              signature={signature}
              selectedSignature={selectedSignature}
              setSelectedSignature={setSelectedSignature}
            />
          </div>
        ))}
        <EmailSignature
          signature={{ id: 0, name: "No Signature" }}
          selectedSignature={selectedSignature}
          setSelectedSignature={setSelectedSignature}
          canEdit={false}
        />
      </div>
      <Button type="secondary" disabled={signatures.length > 2} className="email-signatures--add-btn">
        Add Signature
      </Button>
    </div>
  );
};

EmailSignaturesLibrary.propTypes = {
  selectedSignature: PropTypes.object,
  setSelectedSignature: PropTypes.func.isRequired,
  signatures: PropTypes.array,
};

export default EmailSignaturesLibrary;
